// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const CustomerOrderOfferStateValues = [
	"INITIAL",
	"OFFERED",
	"AWAITING_ACCEPTANCE",
	"ACCEPTED",
	"CUSTOMER_ORDER_CREATED",
	"DISCARDED",
	"LOST",
	"CANCELLED",
] as const;

export type CustomerOrderOfferState = (typeof CustomerOrderOfferStateValues)[number];

export const getCustomerOrderOfferStateLabels = () => ({
	INITIAL: t("initial"),
	OFFERED: t("offered"),
	AWAITING_ACCEPTANCE: t("awaiting_acceptance"),
	ACCEPTED: t("accepted"),
	CUSTOMER_ORDER_CREATED: t("customer_order_created"),
	DISCARDED: t("discarded"),
	LOST: t("lost"),
	CANCELLED: t("cancelled"),
});

export const getCustomerOrderOfferStateLabel = (value: CustomerOrderOfferState): string => {
	return getCustomerOrderOfferStateLabels()[value];
};
